module.exports = __webpack_public_path__ + "img/sirkel_humanisme.43923ec8.png";